
<template>
    <b-form-group
        :label="`${ this.$t(`sidebar.heading.${index.toLowerCase()}`) || index.replace('_', ' ')} ${field.unit ? '(' + field.unit + ')' : ''}`"

    > 
        <b-form-select 
            v-model="fields[index]"
            v-if="field.type == 'select'"
            :options="sanitise(field.options)">
        </b-form-select>
        <b-form-radio-group
            v-else-if="field.type == 'radio'"
            id="radio-group-1"
            v-model="fields[index]"
        >
            <b-form-radio class="text-capitalize" v-for="option,i in field.options" :key="index+i" :value="option">{{ option.replace('_',' ') }}</b-form-radio>
        </b-form-radio-group>
        <b-form-input 
            v-else-if="field.type == 'measurement'|| 'number'"
            type="number"
            :value="fields[index]"
            :min="0"
            @change="handleMeasurementChange"
        />
        <b-form-input 
            v-else
            v-model="fields[index]"
        />
    </b-form-group>
</template>

<script>
/* eslint-disable */
import { minLength } from 'vuelidate/lib/validators';
import EquipmentSubFields from './EquipmentSubFields';
export default {
    props:{
        fields: Object,
        field: Object,
        index: String,
        section: Object
    },
    components:{
        EquipmentSubFields
    },
    computed:{
        subfields(){
            if(this.index in this.fields && 'options' in this.field && !Array.isArray(this.field.options)){
                return this.field.options[this.fields[this.index]].fields || []
            }else{
                return [];
            }            
        }
    },
    methods:{
        sanitise(options){
            return Array.isArray(options)? options : Object.keys(options)
        },

        handleMeasurementChange(val){
            console.log(val)
            const newValue = Number(val);
            this.$set(this.fields, this.index, newValue);
            if(this.$store.getters['projects/item'].asset_type == 'drone' && this.section){
                this.$store.dispatch("gmap/updateShapeFromDimension", {section: this.section, data: { ...this.fields, fromInput: true }})
            }
        }
    },

    // watch: {
    //     fields: {
    //         handler() {
    //             // Logic to perform when fields array changes
    //             debugger
    //             if(this.index == 'width' || this.index == 'length'){
    //                 this.handleMeasurementChange()
    //             }
    //         },
    //         deep: true,
    //     },
    // }
}
</script>